import { InputLabel, Typo, useIsRtlMode } from "@pepperstone/pepper-ui-kit";
import { useState } from "react";

import { FieldError } from "../FieldError";

export type PhoneInputProps = {
  id: string;
  label: string;
  subLabel?: string;
  name: string;
  placeholder?: string;
  autoFocus?: boolean;
  disabled?: boolean;
  value?: string;
  className?: string;
  error?: string;
  maxLength?: number;
  onChange: (value: string) => void;
  onBlur?: () => void;
  onFocus?: () => void;
};

export const PhoneInput = ({
  id,
  label,
  subLabel,
  name,
  placeholder,
  autoFocus = false,
  disabled = false,
  value,
  className,
  maxLength,
  error,
  onChange,
  onBlur,
  onFocus,
}: PhoneInputProps) => {
  const isRtlMode = useIsRtlMode();

  const inputClass = isRtlMode ? "order-1 text-right" : "order-0 text-left";

  const [isFocused, setIsFocused] = useState(false);

  return (
    <div
      className={`flex w-full min-w-40 flex-col gap-y-2 text-base/5 text-[rgb(26,27,27)] ${className}`}
    >
      {label && <InputLabel value={label} htmlFor={id} />}
      {subLabel && (
        <label className="text-xs text-text-secondary antialiased">
          {subLabel}
        </label>
      )}
      <div className="relative w-full">
        <input
          id={id}
          name={name}
          className={`ease-ease relative flex h-10 w-full items-center gap-2 rounded-lg !bg-gray-100 bg-white p-4 px-4 py-2 font-semibold outline !outline-1 !outline-gray-200 outline-border-primary-medium transition-colors duration-300 hover:outline-border-blue-base rtl:flex-row-reverse [&_input]:!outline-0 ${inputClass}`}
          type="tel"
          inputMode="tel"
          onChange={(event) => onChange?.(event.target.value)}
          autoFocus={autoFocus}
          onBlur={() => {
            onBlur?.();
            setIsFocused(false);
          }}
          onFocus={() => {
            onFocus?.();
            setIsFocused(true);
          }}
          value={value}
          disabled={disabled}
          maxLength={maxLength}
        />
        {!isFocused && !value && placeholder && (
          <span className="pointer-events-none absolute inset-0 inset-x-4 flex items-center justify-items-start">
            <Typo elem="p" type="body" size="md" fontFamily="ps-font-sans">
              <label className="text-text-subdued">{placeholder}</label>
            </Typo>
          </span>
        )}
      </div>
      {error && <FieldError text={error} />}
    </div>
  );
};
